import { api } from 'api';

/**
 * cashbox
 ****************************/

/**
 * get payment source for cashbox
 * @returns
 */
export const getPaymentSource = () => {
  return api.call('dictionaries.payment_source');
};

/**
 * change
 ****************************/

/**
 * get payment source for change
 * @returns
 */
export const getRefundRollback = (id) => {
  return api.call('refund.confirm', { payment_id: id });
};


/**
 * update violation status
 * @param {*} params
 * @returns
 */
export const updateViolationState = (params) => {
  return api.call('violations.change_state', params);
};